export const CURRENT_ORDER_ACTIONS = {
  'INIT_CURRENT_ORDER_STATE': 'CURRENT_ORDER_INIT_CURRENT_ORDER_STATE',
  'SET_PATIENT_ID' : 'CURRENT_ORDER_SET_PATIENT_ID',
  'SET_TEST_ID' : 'CURRENT_ORDER_SET_TEST_ID',
  'SET_CURRENT_ORDER': 'CURRENT_ORDER_SET_CURRENT_ORDER',
  'SET_ALL_ORDERS': 'CURRENT_ORDER_SET_ALL_ORDERS',
  'SET_ORDERS_COUNT': 'CURRENT_ORDER_SET_ORDERS_COUNT',
  'SET_IS_NEW_ORDER': 'CURRENT_ORDER_SET_IS_NEW_ORDER',
  'SET_SKIP_NOTES_FETCH': 'CURRENT_ORDER_SKIP_NOTES_FETCH',
  'SET_PATIENT' : 'CURRENT_ORDER_SET_PATIENT',
  'SET_RESOURCE_MAP' : 'CURRENT_ORDER_SET_RESOURCE_MAP',
  'SET_QC_RESULTS' : 'CURRENT_ORDER_SET_QC_RESULTS',
  'SET_REVISION_ID' : 'CURRENT_ORDER_SET_REVISION_ID',
  'UPDATE_FIELDS': 'CURRENT_ORDER_UPDATE_FIELDS',
  'SET_WORKFLOW_DATA': 'CURRENT_ORDER_SET_WORKFLOW_DATA',
  'SET_TEST_DATA': 'CURRENT_ORDER_SET_TEST_DATA',
  'SET_NOTES_DATA': 'CURRENT_ORDER_SET_NOTES_DATA'
};

